var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg20Dc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.822,
    height: 155.868,
    viewBox: "0 0 193.822 155.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 65.99,
    height: 25.373,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M197.693,89.534,189.25,78.279V67.63h79.883V78.279l-8.426,11.255",
    transform: "translate(-102.264 -38.044)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M263.035,113.726l1.73,12.691a80.085,80.085,0,0,0-9.516,4.9c-3.521,2.3-6.172-5.677-11.248-3.748s-10.336,5.427-13.843,3.748-3.457-17.593-3.457-17.593l12.977-6.63Z",
    transform: "translate(-107.316 -43.367)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 42.104,
    height: 14.006,
    transform: "translate(105.88 15.58)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 12.397,
    height: 15.58,
    transform: "translate(119.903)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_197",
    "data-name": "Line 197",
    x2: 6.203,
    transform: "translate(126.106 7.786)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M185.415,107.874,178.2,97.623,227.7,79.94l49.51,17.683L258.776,123.8",
    transform: "translate(-100.773 -39.704)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M271.485,108.781,228.29,92.95,184.81,107.5",
    transform: "translate(-101.665 -41.459)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M176.82,130.64c5.069,0,5.069,3.339,10.139,3.339s5.07-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.07-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.07-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.148,3.339,5.069-3.339,10.148-3.339",
    transform: "translate(-100.587 -46.543)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_198",
    "data-name": "Line 198",
    y2: 47.857,
    transform: "translate(126.928 40.236)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_199",
    "data-name": "Line 199",
    y1: 3.547,
    transform: "translate(113.605 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_200",
    "data-name": "Line 200",
    y1: 3.547,
    transform: "translate(122.066 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_201",
    "data-name": "Line 201",
    y1: 3.547,
    transform: "translate(130.535 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    y1: 3.547,
    transform: "translate(138.996 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9164",
    "data-name": "Group 9164",
    transform: "translate(126.582 86.796)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M176.82,141.64c5.069,0,5.069,3.339,10.139,3.339s5.07-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.07-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.07-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.148,3.339,5.069-3.339,10.148-3.339",
    transform: "translate(-227.169 -134.823)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M194.094,209.141l1.306-3.331a1.73,1.73,0,0,0,.1-1.194.96.96,0,0,0-1.272-.683.986.986,0,0,0-.761,1.047.4.4,0,0,1-.268.407.363.363,0,0,1-.493-.242.787.787,0,0,1,0-.138,1.836,1.836,0,0,1,3.59-.623,2.422,2.422,0,0,1-.156,1.73l-1.177,2.95h0l2.2-.657a.372.372,0,1,1,.216.709l-2.872.865a.355.355,0,0,1-.476-.225.865.865,0,0,1,.061-.614Z",
    transform: "translate(-102.73 -56.32)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M198.926,205.243a7.423,7.423,0,0,1-.476-2.068,1.895,1.895,0,0,1,3.391-1.021,15.762,15.762,0,0,1,1.22,4.049,1.886,1.886,0,0,1-3.391,1.021A7.439,7.439,0,0,1,198.926,205.243Zm2.6,1.938a.96.96,0,0,0,.753-.865,18.166,18.166,0,0,0-1.125-3.737,1.064,1.064,0,0,0-1.877.562,18.166,18.166,0,0,0,1.125,3.737.96.96,0,0,0,1.073.311Z",
    transform: "translate(-103.505 -56.091)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M208.466,201.022a.326.326,0,0,1,.19.623l-.649.2a.052.052,0,0,0,0,.069l1,3.331a.4.4,0,0,1-.761.234l-1-3.331a.052.052,0,0,0-.069,0l-.242.078a.326.326,0,0,1-.19-.623l.242-.078a.052.052,0,0,0,0-.069l-.112-.381c-.311-1.047,0-1.523.926-1.8h.061a.363.363,0,0,1,.51.234.355.355,0,0,1-.268.467c-.562.173-.64.311-.484.865l.13.433a.052.052,0,0,0,.069,0Z",
    transform: "translate(-104.593 -55.797)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M212.841,204.627c-.865.268-1.332,0-1.609-.917l-.735-2.448a.052.052,0,0,0-.069,0l-.242.078a.324.324,0,0,1-.182-.623l.242-.078a.052.052,0,0,0,0-.069l-.285-.96a.4.4,0,1,1,.77-.234l.285.96a.052.052,0,0,0,.069,0l.571-.173a.326.326,0,1,1,.19.623l-.571.173a.052.052,0,0,0,0,.069L212,203.45c.138.467.3.562.761.424a.355.355,0,0,1,.484.242c.061.208,0,.4-.3.476Z",
    transform: "translate(-105.032 -55.777)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M154.111,204.57l-3.261,3.512,4.161,2.37",
    transform: "translate(-97.084 -56.517)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M236.04,187.034l3.261-3.5-4.161-2.37",
    transform: "translate(-108.455 -53.359)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    y1: 21.394,
    x2: 77.081,
    transform: "translate(53.766 130.172)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M215.61,117.881v-5.609l-49.363-.052L88.7,114.478v10.467",
    transform: "translate(-88.7 -44.059)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M88.7,170.343l49.873,16.411V117.217L88.7,114.76Z",
    transform: "translate(-88.7 -44.401)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M91.94,119.94v47.312l43.861,13.7V123.184Z",
    transform: "translate(-89.137 -45.1)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_204",
    "data-name": "Line 204",
    x2: 0.069,
    y2: 51.664,
    transform: "translate(24.526 77.141)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    y2: 59.484,
    transform: "translate(37.606 75.437)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    y2: 56.785,
    transform: "translate(28.393 75.03)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_207",
    "data-name": "Line 207",
    y2: 54.562,
    transform: "translate(20.373 74.684)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_208",
    "data-name": "Line 208",
    y2: 52.218,
    transform: "translate(11.662 74.217)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M91.325,117.485c0,.424-.164.744-.372.718s-.363-.407-.363-.865.164-.744.363-.718S91.325,117.061,91.325,117.485Z",
    transform: "translate(-88.955 -44.652)",
    fill: "#131924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M143.852,120.831c0,.554-.216.969-.476.926s-.476-.528-.476-1.081.216-.969.476-.926S143.852,120.26,143.852,120.831Z",
    transform: "translate(-96.011 -45.074)",
    fill: "#131924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M95.49,127.46V131.7l14.5,1.505v-4.23Z",
    transform: "translate(-89.616 -46.114)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M121.92,130.27v4.144l15.131,1.67v-4.239Z",
    transform: "translate(-93.181 -46.494)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M121.92,151.67v3.91l15.053,2.829V154.5Z",
    transform: "translate(-93.181 -49.38)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M121.92,171.01v3.616l14.837,3.72v-3.607Z",
    transform: "translate(-93.181 -51.989)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M95.49,146.84v3.91l14.5,2.647v-3.91Z",
    transform: "translate(-89.616 -48.729)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M95.49,164.56v3.616l14.5,3.538V168.1Z",
    transform: "translate(-89.616 -51.119)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M146.28,186.256V116.685l4.646-.225-.017,1.194,69.026-5.589v-1.107l3.443-.208-.017,54.856Z",
    transform: "translate(-96.467 -43.86)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M147.25,123.771l4.239-.311v58.334l-4.239,1.038",
    transform: "translate(-96.598 -45.575)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M172.457,177.144V121.7l-4.057.346V178.1Z",
    transform: "translate(-99.451 -45.337)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M161.987,179.478v-56.9l-4.057.355v57.5Z",
    transform: "translate(-98.039 -45.456)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M178.34,175.9l3.858-.934V120.84l-3.858.355Z",
    transform: "translate(-100.792 -45.221)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M188.78,173.573l3.642-.882V119.98l-3.642.32Z",
    transform: "translate(-102.201 -45.105)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M199,171.322l3.434-.839V119.13l-3.434.294Z",
    transform: "translate(-103.579 -44.991)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M208.76,169.126l3.227-.779V118.31l-3.227.285Z",
    transform: "translate(-104.896 -44.88)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M218.29,167.011l3.011-.744V117.51l-3.011.268Z",
    transform: "translate(-106.181 -44.772)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M227.11,165.025l2.812-.683v-47.7l-2.812.242Z",
    transform: "translate(-107.371 -44.655)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 0.329,
    cy: 0.796,
    rx: 0.329,
    ry: 0.796,
    transform: "translate(51.828 74.944)",
    fill: "#131924"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Dc);
export default __webpack_public_path__ + "static/media/20dc.2813a447fa8705f859ca8956f2c1b2a1.svg";
export { ForwardRef as ReactComponent };